module.exports = __webpack_public_path__ + "img/nueva.7a1170a1.jpg";